import { Component, NgZone, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NbThemeService } from "@nebular/theme";
import { CookieService } from "ngx-cookie-service";
import { AnalyticsService } from "../../@core/utils";
import { StorageService } from "../../services/storage.service";
import { User } from "../../interface/user";

@Component({
  selector: "ngx-change-theme",
  templateUrl: "./change-theme.component.html",
  styleUrls: ["./change-theme.component.scss"],
})
export class ChangeThemeComponent implements OnInit {
  theme = "material-light";
  isShowTutorial = true;
  user: User;
  isLightMode;
  public isSidebarClose: boolean = true;

  constructor(
    private themeService: NbThemeService,
    private cookieService: CookieService,
    public analyticsService: AnalyticsService,
    public storageService: StorageService,
    public router: Router,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    try {
      const cookieValue = this.cookieService.get("Theme");
      const storageItem = this.storageService.getItem("isShowTutorial");
      this.user = this.storageService.getItem("user");

      this.isShowTutorial = storageItem === false ? false : true;

      if (cookieValue) {
        this.ngZone.runOutsideAngular(() => {
          setTimeout(() => {
            this.ngZone.run(() => {
              this.theme = cookieValue;
              this.isLightMode = this.theme !== "material-light";
              this.themeService.changeTheme(cookieValue);
              if (
                this.router.url.includes("login") ||
                this.router.url.includes("administration") ||
                this.router.url.includes("sign-up")
              ) {
                this.changeMode("material-light");
              }
            });
          });
        });
      }

      this.themeService.onThemeChange().subscribe((res) => {
        this.analyticsService.currentTheme = res?.name;
      });
    } catch (error) {
      // console.log(error);
    }
  }

  changeMode(themeName) {
    try {
      this.analyticsService?.trackEvent("Change Theme", themeName);
      this.theme = themeName;
      this.themeService.changeTheme(themeName);
      this.cookieService.set("Theme", themeName);
    } catch (error) {
      // console.log(error);
    }
  }
  toggleTheme() {
    this.theme =
      this.theme === "material-light" ? "material-dark" : "material-light";
    this.changeMode(this.theme);
  }
  setTutorialConfig(show = false): void {
    this.isShowTutorial = show;
    this.storageService.hideTutorials.emit(show);
  }

  showTotorial() {
    try {
      this.isShowTutorial = !this.isShowTutorial;
      this.setTutorialConfig(this.isShowTutorial);
    } catch (error) {}
  }
}
